import { useQuery } from '@tanstack/react-query'
import { ApiError } from '../api/client'
import { runReport } from '../api/reports'
import { ResultView } from './ResultView'
import type { Drill } from './useDrill'
import type { Locale } from './types'

/**
 * "ARATA-MI RANDURILE": dupa un click pe o bara, un punct sau un rand grupat,
 * inregistrarile din spatele lui, sub rezultat - aceeasi definitie fara
 * grupare, cu valorile grupului ca filtre (`drillDefinition`), rulata cu
 * limitele previzualizarii. Nu schimba raportul.
 */

export function DrillPanel({ company, drill, locale, onClose }: { company: number; drill: Drill; locale: Locale; onClose: () => void }) {
  const q = useQuery({
    queryKey: ['reports', 'run', company, JSON.stringify(drill.definition)],
    queryFn: () => runReport(company, drill.definition),
    enabled: company > 0,
    retry: false,
    staleTime: 30 * 1000,
  })
  const t = (ro: string, en: string) => (locale === 'ro' ? ro : en)
  return (
    <div className="od-rep-drill" role="region" aria-label={t('Inregistrarile din spatele randului', 'The records behind the row')}>
      <div className="od-rep-drill-head">
        <b>{t('Inregistrarile pentru', 'Records for')}: </b>
        <span>{drill.title}</span>
        {q.data?.truncated ? <span className="od-rep-meta"> · {t(`primele ${q.data.limit}`, `first ${q.data.limit}`)}</span> : null}
        <button type="button" className="od-rep-x" aria-label={t('Inchide', 'Close')} onClick={onClose}>
          ×
        </button>
      </div>
      {q.isFetching && !q.data ? <div className="od-rep-hint">{t('Se incarca…', 'Loading…')}</div> : null}
      {q.error ? <div className="od-rep-hint">{q.error instanceof ApiError ? q.error.message : String(q.error)}</div> : null}
      {q.data ? <ResultView result={q.data} locale={locale} /> : null}
    </div>
  )
}
